import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotSelected = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={196}
    height={196}
    viewBox="0 0 196 196"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g clipPath="url(#not-selected_svg__a)">
      <path d="M98 196c54.124 0 98-43.876 98-98S152.124 0 98 0 0 43.876 0 98s43.876 98 98 98Z" fill="#E8EEFF" />
      <path
        d="m120.8 66.596-7.808-2.842a1.512 1.512 0 0 0-1.034 2.84l7.809 2.842a1.51 1.51 0 1 0 1.033-2.84ZM103.748 113.448l-7.808-2.842a1.51 1.51 0 1 0-1.034 2.839l7.809 2.842a1.51 1.51 0 1 0 1.033-2.839Z"
        fill="#E8ECEE"
      />
      <g filter="url(#not-selected_svg__b)">
        <path
          d="M49.695 59.442a4 4 0 0 1 3.244-4.634l43.332-7.64 27.803 19.468 11.808 66.967a4 4 0 0 1-3.245 4.633L69.609 149.35a4 4 0 0 1-4.633-3.245L49.695 59.442Z"
          fill="#fff"
        />
        <path d="M124.074 66.636 96.271 47.168l3.473 19.696a4 4 0 0 0 4.634 3.245l19.696-3.473Z" fill="#DCE1E4" />
      </g>
      <path
        d="m89.81 59.476-29.544 5.21a1.5 1.5 0 0 0 .521 2.954l29.545-5.21a1.5 1.5 0 1 0-.521-2.954ZM117.38 89.14l-50.225 8.856a1.5 1.5 0 0 0 .52 2.955l50.226-8.856a1.5 1.5 0 1 0-.521-2.955ZM103.879 102.183l-34.468 6.078a1.499 1.499 0 1 0 .52 2.954l34.469-6.078a1.5 1.5 0 1 0-.521-2.954ZM100.406 82.486l-34.468 6.078a1.5 1.5 0 0 0 .521 2.954l34.468-6.078a1.5 1.5 0 1 0-.521-2.954ZM109.555 111.336l-38.408 6.773a1.499 1.499 0 1 0 .521 2.954l38.408-6.772a1.5 1.5 0 0 0-.521-2.955ZM73.473 70.48l-11.818 2.085a1.5 1.5 0 0 0 .52 2.954l11.819-2.084a1.5 1.5 0 0 0-.521-2.954ZM84.238 131.539l-11.817 2.084a1.499 1.499 0 1 0 .52 2.954l11.818-2.084a1.5 1.5 0 0 0-.52-2.954Z"
        fill="#DCE1E4"
      />
      <g filter="url(#not-selected_svg__c)">
        <path
          d="M74.946 49.118a4 4 0 0 1 4.269-3.711l43.893 3.07 22.267 25.615-4.743 67.834a4.001 4.001 0 0 1-4.27 3.712l-63.844-4.465a4 4 0 0 1-3.711-4.269l6.139-87.786Z"
          fill="#fff"
        />
        <path d="m145.375 74.092-22.268-25.615-1.395 19.95a4 4 0 0 0 3.712 4.27l19.951 1.395Z" fill="#DCE1E4" />
      </g>
      <path
        d="m113.861 58.856-29.927-2.092a1.5 1.5 0 1 0-.21 2.992l29.927 2.093a1.5 1.5 0 1 0 .21-2.992ZM133.437 94.309 82.561 90.75a1.5 1.5 0 0 0-.21 2.993l50.876 3.557a1.5 1.5 0 1 0 .21-2.992ZM117.181 103.697l-34.915-2.441a1.5 1.5 0 1 0-.21 2.992l34.915 2.442a1.5 1.5 0 0 0 .21-2.993ZM118.575 83.746 83.66 81.305a1.5 1.5 0 1 0-.209 2.992l34.915 2.442a1.5 1.5 0 0 0 .209-2.993ZM120.474 113.952l-38.905-2.72a1.5 1.5 0 1 0-.21 2.992l38.905 2.721a1.5 1.5 0 0 0 .21-2.993ZM95.346 65.581l-11.97-.837a1.5 1.5 0 1 0-.21 2.993l11.97.837a1.5 1.5 0 1 0 .21-2.993ZM91.022 127.43l-11.971-.837a1.5 1.5 0 1 0-.21 2.992l11.972.837a1.5 1.5 0 1 0 .209-2.992Z"
        fill="#DCE1E4"
      />
      <path d="M132.5 152.5c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z" fill="#184F81" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m140.952 135.59-13.921-8.459 1.585 16.212 3.856-4.818 4.18 6.651 2.467-1.551-4.18-6.65 6.013-1.385Z"
        fill="#fff"
      />
    </g>
    <defs>
      <filter
        id="not-selected_svg__b"
        x={-6.367}
        y={15.168}
        width={198.31}
        height={214.243}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect1_dropShadow_9_71" result="effect2_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={12} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect2_dropShadow_9_71" result="effect3_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={28} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_9_71" result="effect4_dropShadow_9_71" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_9_71" result="shape" />
      </filter>
      <filter
        id="not-selected_svg__c"
        x={4.797}
        y={5.397}
        width={204.578}
        height={228.251}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={8} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_9_71" result="effect2_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={16} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect2_dropShadow_9_71" result="effect3_dropShadow_9_71" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={32} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_9_71" result="effect4_dropShadow_9_71" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_9_71" result="shape" />
      </filter>
      <clipPath id="not-selected_svg__a">
        <rect width={196} height={196} rx={98} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNotSelected;
